// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================= PRODUCT CATEGORIES ================= */

.product-categories {
  background: #f5f7fa;
  padding: 60px 0;
}

.pc-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.pc-header h2 {
  font-size: 1.4rem;
    font-weight: 600;
    letter-spacing: 1px;
    color: rgb(14 16 18);
}

.pc-header .view-all {
  color: #034EA2;
  font-weight: 600;
  text-decoration: none;
  font-size: 15px;
}

.pc-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
}

.pc-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
  position: relative;
  transition: transform 0.2s ease;
}

.pc-card:hover {
  transform: translateY(-5px);

}

.pc-badge {
  position: absolute;
  top: 18px;
  right: 18px;
  background: #f1f3f6;
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 20px;
}

.pc-card h3 {
  font-size: 18px;
  margin-bottom: 16px;
  font-weight: 700;
  font-style: normal;
}

.pc-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.pc-card li {
  margin-bottom: 10px;
    /* display: inline-block; */
    padding: 2px 1px;
    cursor: pointer;
    transition: color 0.3s ease;
    margin-left: 10px;
}

.pc-card li a {
  text-decoration: none;
  color: #333;
  font-size: 0.840rem;
}

.pc-card li a:hover {
  color: #034EA2;
}

/* View All Card */
.pc-view-all {
  text-align: center;
  border: 2px dashed #d0d5dd;
}

.pc-view-all .icon {
  font-size: 32px;
  margin-bottom: 36px;
}

.pc-view-all p {
  font-size: 14px;
  color: #666;
}

.browse-all {
  display: inline-block;
  margin-top: 12px;
  color: #034EA2;
  text-decoration: none;
  font-weight: 500;
}

.pc-card li:hover {
    color: #034EA2; /* Changes text color to a corporate blue */
    background-color: #03a9f421;
}

/* ================= MOBILE ================= */
@media (max-width: 768px) {
  .pc-header {
    flex-direction: column;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/productCategories.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;;AAE7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;IACjB,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;IACI,cAAc,EAAE,2CAA2C;IAC3D,2BAA2B;AAC/B;;AAEA,+CAA+C;AAC/C;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF","sourcesContent":["/* ================= PRODUCT CATEGORIES ================= */\r\n\r\n.product-categories {\r\n  background: #f5f7fa;\r\n  padding: 60px 0;\r\n}\r\n\r\n.pc-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.pc-header h2 {\r\n  font-size: 1.4rem;\r\n    font-weight: 600;\r\n    letter-spacing: 1px;\r\n    color: rgb(14 16 18);\r\n}\r\n\r\n.pc-header .view-all {\r\n  color: #034EA2;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  font-size: 15px;\r\n}\r\n\r\n.pc-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 40px;\r\n}\r\n\r\n.pc-card {\r\n  background: #ffffff;\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);\r\n  position: relative;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.pc-card:hover {\r\n  transform: translateY(-5px);\r\n\r\n}\r\n\r\n.pc-badge {\r\n  position: absolute;\r\n  top: 18px;\r\n  right: 18px;\r\n  background: #f1f3f6;\r\n  padding: 4px 10px;\r\n  font-size: 12px;\r\n  border-radius: 20px;\r\n}\r\n\r\n.pc-card h3 {\r\n  font-size: 18px;\r\n  margin-bottom: 16px;\r\n  font-weight: 700;\r\n  font-style: normal;\r\n}\r\n\r\n.pc-card ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.pc-card li {\r\n  margin-bottom: 10px;\r\n    /* display: inline-block; */\r\n    padding: 2px 1px;\r\n    cursor: pointer;\r\n    transition: color 0.3s ease;\r\n    margin-left: 10px;\r\n}\r\n\r\n.pc-card li a {\r\n  text-decoration: none;\r\n  color: #333;\r\n  font-size: 0.840rem;\r\n}\r\n\r\n.pc-card li a:hover {\r\n  color: #034EA2;\r\n}\r\n\r\n/* View All Card */\r\n.pc-view-all {\r\n  text-align: center;\r\n  border: 2px dashed #d0d5dd;\r\n}\r\n\r\n.pc-view-all .icon {\r\n  font-size: 32px;\r\n  margin-bottom: 36px;\r\n}\r\n\r\n.pc-view-all p {\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n.browse-all {\r\n  display: inline-block;\r\n  margin-top: 12px;\r\n  color: #034EA2;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.pc-card li:hover {\r\n    color: #034EA2; /* Changes text color to a corporate blue */\r\n    background-color: #03a9f421;\r\n}\r\n\r\n/* ================= MOBILE ================= */\r\n@media (max-width: 768px) {\r\n  .pc-header {\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
